import getSafeRedirectUrl from './getSafeRedirectUrl';

export default getSafeRedirectUrl;
